export default __webpack_public_path__ + "static/media/tour-e-agency-desktop-two.068a6058.png";